jQuery(document).ready(function($) {
  /** Price table action */
  $('.price-plan__tab .button').on('click', function() {
    var $this = $(this),
        type = $this.data('type');

    $('.price-plan__tab .button').removeClass('active');
    $this.addClass('active');

    if ( type == 'monthly-plan' ) {
      $('.price-plan__items').removeClass('yearly-active').addClass('monthly-active');
    } else {
      $('.price-plan__items').removeClass('monthly-active').addClass('yearly-active');
    }
  });

  $('.plan-items_tab-mobile .plan-item-name').on('click', function() {
    var $this = $(this),
        id = $this.data('id');

    $('.plan-items_tab-mobile .plan-item-name').removeClass('active');
    $('.price-plan__items .plan-item').removeClass('active');
    $this.addClass('active');
    $('.price-plan__items .plan-item[data-id="'+ id +'"]').addClass('active');
  });

  /** Price plan checkout */
  $('.plan-item .pay-action .button').on('click', function() {
    var $this = $(this),
        variantID = $this.data('variant-id'),
        sellingID = $this.data('selling-id');

    $.ajax({ // Clear Cart
      type: 'POST',
      url: '/cart/clear.js',
      dataType: 'json',
      success: function() {
        $.ajax({ // Add items to Cart
          type: 'POST',
          url: '/cart/add.js',
          data: {
            id: variantID,
            quantity: 1,
            selling_plan: sellingID
          },
          dataType: 'json',
          success: function() {
            window.location.href = '/checkout';
          }
        });
      }
    });
  });
});